import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
          _cache[0] || (_cache[0] = _createElementVNode("i", { class: "fas fa-spinner fa-pulse" }, null, -1)),
          (_ctx.showText)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.$t("job.scm.status.loading.message")), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.jobSynchState)
      ? (_openBlock(), _createElementBlock("span", {
          key: 1,
          title: _ctx.jobText,
          class: "scm_status"
        }, [
          _createElementVNode("span", {
            class: _normalizeClass(_ctx.jobClass)
          }, [
            _createElementVNode("i", {
              class: _normalizeClass([_ctx.jobIcon, "glyphicon"])
            }, null, 2),
            _createTextVNode(" " + _toDisplayString(_ctx.displayText), 1)
          ], 2)
        ], 8, _hoisted_3))
      : _createCommentVNode("", true)
  ], 64))
}